/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
// import { InvoicePaidStatus } from '@msdyn365-commerce/retail-proxy';

export interface IInvoiceStatusResources {
    invoiceStatusNone: string;
    invoiceStatusUnpaid: string;
    invoiceStatusPartiallyPaid: string;
    invoiceStatusPaid: string;
    pastDueText: string;
}

export enum InvoicePaidStatus {
    /**
     * The None member.
     */
    None = 0,
    /**
     * The Unpaid member.
     */
    Unpaid = 1,
    /**
     * The PartiallyPaid member.
     */
    PartiallyPaid = 2,
    /**
     * The Paid member.
     */
    Paid = 3,

    // NEW
    /**
     * The PastDue member.
     */
    PastDue = 4
}

export const getInvoiceStatusText = (resources: IInvoiceStatusResources, invoiceStatus: InvoicePaidStatus | undefined) => {
    switch (invoiceStatus) {
        case InvoicePaidStatus.None:
            return resources.invoiceStatusNone;

        case InvoicePaidStatus.Unpaid:
            return resources.invoiceStatusUnpaid;

        case InvoicePaidStatus.PartiallyPaid:
            return resources.invoiceStatusPartiallyPaid;

        case InvoicePaidStatus.Paid:
            return resources.invoiceStatusPaid;

        case InvoicePaidStatus.PastDue:
            return resources.pastDueText;
        default:
            return '';
    }
};
